import React from "react";
import { useTranslation } from "react-i18next";

function DeleteModel({ confirmDelete, cancelDelete, isDeleting }) {
  const { t } = useTranslation("addProductsHeader");

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-20">
      <div className="bg-white p-6 rounded-lg shadow-lg max-w-[400px] w-full text-center flex flex-col gap-6">
        <h2 className="text-2xl font-extrabold text-[#292929] m-0">
          {t("confirmTitle")}
        </h2>
        <p className="text-base text-[#464646] font-normal m-0 leading-6">
          {t("confirmDescription")}
        </p>
        <div className="flex flex-row gap-4 justify-center">
          <button
            className="px-6 py-3 rounded-lg cursor-pointer text-base font-bold text-white bg-primary border-2 border-primary hover:bg-[#4d07c2]"
            onClick={confirmDelete}
          >
            {isDeleting ? t("deletingButton") : t("confirmButton")}
          </button>
          <button
            className="px-6 py-3 rounded-lg cursor-pointer text-base font-bold text-primary bg-white border-2 border-primary hover:bg-[#f0f0f0]"
            onClick={cancelDelete}
          >
            {t("cancelButton")}
          </button>
        </div>
      </div>
    </div>
  );
}

export default DeleteModel;
